import React from 'react';
import { useSelector } from 'react-redux';
import LineGraph from './LineGraph';
import useGraphLogData from 'utils/customHook/useGraphLogData';
import moment from 'moment';

const MainPopup = (props) => {
  const criterion = useSelector((store) => store.criterion.gas);
  const logData = useGraphLogData(props.title, props.moduleIdx);

  if (!logData || logData.length === 0) {
    return null;
  }
  const seriesData = logData.map(dataPoint => dataPoint.temp);

  const categoriesData = logData.map(dataPoint =>
    moment(dataPoint.rgstDt).format('HH:mm:ss')
  );

  return (
    <div style={{ width: '70vw', height: '70vh', color: 'white' }}>
      <LineGraph
        graphId='heatindex'
        criterion={criterion.heatindex}
        data={seriesData}
        categories={categoriesData.reverse()}
      />
      <LineGraph
        graphId='temp'
        criterion={criterion.temp}
        data={seriesData}
        categories={categoriesData.reverse()}
      />
      <LineGraph
        graphId='humi'
        criterion={criterion.humi}
        data={seriesData}
        categories={categoriesData.reverse()}
      />
    </div>
  );
};

export default React.memo(MainPopup);



{/* <LineGraphMain data={lineData} criterion={criterion} {...props} />
      <CircleGraphMain criterion={criterion} {...props} /> */}
{/* <LegendContainer>
        {graphOrder[props.moduleScn].map((key) => {
          return (
            <div className="contentBox" key={key}>
              <div className="title">법적관리기준</div>
              <div>
                {criterion[key]
                  .filter((x) => x.standType === 'criterion')
                  .map((data) => {
                    return `${data.standVal}${utmMap[key] === '' ? '' : `(${utmMap[key]})`}${reverseRangeMap[data.standRange]}`;
                  })
                  .join(' ')}
              </div>
            </div>
          );
        })}
      </LegendContainer> */}